import React from 'react';

function LoadingSkeleton() {
    return (
        <div className="flex flex-col items-center justify-center p-4 space-y-4">
            <div className="w-20 h-20 bg-base-300 rounded-full animate-pulse"></div>

            <div className="w-full max-w-sm space-y-2">
                <div className="h-4 bg-base-300 rounded animate-pulse"></div>
                <div className="h-4 bg-base-300 rounded animate-pulse"></div>
                <div className="h-4 bg-base-300 rounded animate-pulse"></div>
            </div>
        </div>
    );
}

export default function Loading() {
    return <LoadingSkeleton />;
}
